import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';
import {
    AutocompleteChangeDetails,
    AutocompleteChangeReason,
} from '@mui/material';

import Api from '@barboxx/api';
import { PourType } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
    onChange?: (
        event: React.SyntheticEvent,
        value: NonNullable<string | PourType> | null,
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<PourType> | undefined
    ) => void;
}

interface PourTypeWatchProps {
    pourType: PourType;
}

export function PourTypeInput({ disabled = false, onChange }: Props) {
    const { pourType } = useFormContext<PourTypeWatchProps>().getValues();
    const pourTypeQueryResult = useQuery({
        queryKey: ['pourTypes'],
        queryFn: () =>
            Api.Servings.PourType.getPourTypes({
                page: 0,
                size: 1000,
                sort: 'name,asc',
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: pourType ? [pourType] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Pour Type"
            name="pourTypeId"
            loading={pourTypeQueryResult.isLoading}
            multiple={false}
            options={pourTypeQueryResult.data?.data?.results ?? []}
            // onChange={() => onChange?.()}

            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                onChange: onChange,
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: PourType,
                    value?: PourType | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.name}`;
                },
            }}
        />
    );
}
